import Text from "components/general/Text";
import styles from "./styles.module.scss";
import SecondaryPageHeader from "components/general/SecondaryPageHeader";
import Button from "components/general/Button";
import { useState } from "react";
import UploadLeaveDocuments from "components/modals/UploadLeaveDocuments";
import EmptyState from "components/general/EmptyState";
import Table from "components/general/Table";
import IMPORTANT_VARS from "constants/ImportantVars";
import { useSearchParams } from "react-router-dom";
import moment from "moment";
import { useGetLeaveBalanceUploadLogsQuery } from "apis/services/other";
import { capitalize } from "lodash-es";
import sync_icon from "assets/icons/sync.svg";
import showSuccessMsg from "utils/showSuccessMsg";
import usePermissions from "hooks/usePermission";
import { PermissionCodename } from "constants/permission";

export default function LeaveDocuments() {
  const [isUploadingFile, setisUploadingFile] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const { hasPermissionTo } = usePermissions()
  const create_leave_balance_bulk_upload = hasPermissionTo("create_leave_balance_bulk_upload")

  const { data, isLoading, isFetching, refetch } =
    useGetLeaveBalanceUploadLogsQuery({
      page_size: IMPORTANT_VARS.TabelDataPageSize,
      page: searchParams.get("page") ?? "1",
      search: searchParams.get("search") ?? "",
    });

  const onShowAddModal = () => {
    setisUploadingFile(true);
  };

  const handleRefetch = () => {
    refetch();
    showSuccessMsg({ msg: "Everything is up to date" });
  };

  const emptyState = {
    no_data: {
      title: "No Leave Documents",
      description:
        "You Haven’t Uploaded Any Documents. Upload Leave Sheets, HR Forms, Or Other Files To Get Started.",
      buttonText: `+ ${" "} Import New Leave File`,
      onClick: onShowAddModal,
    },
    no_search_results: {
      title: "No Search Results",
      description: (
        <>
          We couldn’t find any documents matching "
          <strong>{searchParams.get("search")}</strong>". Try checking the file
          name or adjusting your filters.
        </>
      ),
      buttonText: "Clear Search",
      onClick: () => {
        const nextSearchParams = new URLSearchParams(searchParams);
        nextSearchParams.delete("search");
        nextSearchParams.delete("page");
        setSearchParams(nextSearchParams);
      },
    },
  };

  const currentEmptyState =
    searchParams.get("search") && !data?.results.length
      ? emptyState.no_search_results
      : emptyState.no_data;

  const changeStaffData = (item: any): any => ({
    id: String(item.id),
    rowData: [
      {
        type: "text",
        // @ts-ignore
        dataItem: `#${item.id}` ?? "-",
      },
      {
        type: "text",
        dataItem: item.file_name ?? "-",
      },
      {
        type: "text",
        dataItem: moment(item.created_at).format("DD-MM-YYYY") ?? "-",
      },
      {
        type: "text",
        dataItem: capitalize(item.upload_status) ?? "-",
      },
      {
        type: "text",
        dataItem: item?.error_message ?? "-",
      },
      {
        type: "element",
        dataItem: "",
      },
    ],
  });

  return (
    <section>
      <SecondaryPageHeader
        title="Leave Documents"
        RightComponent={
          <div className={styles.headerBtnContainer}>
            {create_leave_balance_bulk_upload && (
              <Button btnClassName={styles.headerBtn} onClick={onShowAddModal}>
                + Import New Leave File
              </Button>
            )}
            <Button onClick={handleRefetch} isLoading={isLoading || isFetching}>
              <img src={sync_icon} alt="refresh" width={28} height={28} />
            </Button>
          </div>
        }
      />

      <div className={styles.tableContainer}>
        <Table
          isCheckBoxVisible
          showSearchFilter
          isFilterBtnVisible={false}
          isLoading={isLoading}
          searchPlaceholder="Search for files"
          headers={[
            "File ID",
            "File Name",
            "Date",
            "Status",
            "Error Message",
            "",
          ]}
          data={data?.results.map((item: any) => changeStaffData(item)) ?? []}
          emptyState={<EmptyState {...currentEmptyState} />}
          count={data?.count}
          pageSize={IMPORTANT_VARS.TabelDataPageSize}
        />
      </div>

      <UploadLeaveDocuments
        isVisible={isUploadingFile}
        setIsVisible={() => setisUploadingFile(false)}
        page="documents"
      />
    </section>
  );
}
